import { PAGE_URL } from "./constants";
import { capitalize } from "lodash";

/**
 * Generate profile/event/circle URL based on type and id
 */
export const getProfileUrl = (type: string, id: string): string => {
  switch (type) {
    case "USER":
      return `${PAGE_URL.profile}/${id}`;
    case "CIRCLE":
      return `${PAGE_URL.circles}/${id}`;
    case "EVENT":
      return `${PAGE_URL.events}/${id}`;
    default:
      return "/";
  }
};

/**
 * Check if context reference should be rendered
 */
export const shouldShowContextReference = (context: string, contextReference: any): boolean =>
  [
    "circleInvitations",
    "eventInvitations",
    "eventRecommendations",
    "circleRecommendations",
    "connectionRecommendations",
  ].includes(context) && contextReference;

/**
 * Check if skill context reference should be rendered
 */
export const shouldShowContextReferenceSkill = (context: string, contextReference: any): boolean =>
  ["skillRecommendations", "skillVerificationRequests"].includes(context) && contextReference;

/**
 * Get custom reference type description
 */
export const getCustomReferenceType = (contextReference: any): string => {
  if (!contextReference) return "";
  
  return contextReference?.isHidden
    ? `Hidden ${capitalize(contextReference?.type)}`
    : contextReference?.privacy === "PUBLIC"
    ? `Public ${capitalize(contextReference?.type)}`
    : `Private ${capitalize(contextReference?.type)}`;
};

/**
 * Check if action buttons should be rendered
 */
export const shouldRenderActionBtn = (context: string, additionalInfo?: any): boolean => {
  if (context === "mentorshipRequests") {
    if (additionalInfo?.isConnectionRequest) return false;
    return true;
  } else {
    if (
      [
        "endorsements",
        "relationshipUpgradeRequests",
        "championRequests",
      ].includes(context)
    )
      return true;
    return false;
  }
};

/**
 * Check if connection activity request buttons should be rendered
 */
export const shouldRenderActionBtnConnectActReq = (
  context: string, 
  description: string, 
  additionalInfo?: any
): boolean => {
  if (context?.includes("connectionActivities")) {
    if (additionalInfo?.isConnectionRequest) return false;
    if (description?.includes("wants to connect with you")) return true;
    if (description?.includes("would like to change your relationship"))
      return true;
    return false;
  }
  return false;
};

/**
 * Check if single connection request button should be rendered
 */
export const shouldRenderConnectionReqSingleBtn = (
  context: string, 
  additionalInfo?: any
): boolean => {
  if (
    context?.includes("connectionActivities") ||
    context?.includes("mentorshipRequests")
  ) {
    if (additionalInfo?.isConnectionRequest) return true;
    return false;
  }
  return false;
};
